import React from 'react';
import PropTypes from 'prop-types';

import PlayForWorkIcon from '@mui/icons-material/PlayForWork'; // Drop Icon
import FlightIcon from '@mui/icons-material/Flight'; // Flying Icon
import FlightLandIcon from '@mui/icons-material/FlightLand'; // Landing Icon
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff'; // Take Off Icon

const FlightPlannerIcon = ({ variant, color }) => {
  const style = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: color ? color : 'black'
  };

  let icon;
  switch (variant) {
    case 'startpoint':
      icon = <FlightTakeoffIcon />;
      break;
    case 'endpoint':
      icon = <FlightLandIcon />;
      break;
    case 'drop':
      icon = <PlayForWorkIcon />;
      break;
    default:
      icon = <FlightIcon />;
  }

  return <div style={style}>{icon}</div>;
};

FlightPlannerIcon.propTypes = {
  variant: PropTypes.oneOf(['startpoint', 'endpoint', 'drop', 'point']),
  color: PropTypes.string
};

FlightPlannerIcon.defaultProps = {
  color: 'black'
};

export default FlightPlannerIcon;
